export enum ActionEditType {
  Edit = 0,
  Translate = 1,
}
